import React from 'react';
import truncate from 'truncate-markup-string';

import {
  Image,
  WysiwygField,
} from '@uncinc/uncinc-react-kitchen-sink';
import './style.scss';

const InfographicItem = ({ item, toggle }) => {
  const charLimit = 80;
  const openTag = '<span>';
  const closeTag = '</span>';
  const prettyEllipsis = true;

  const title = item.getIn(['entity', 'field_title', 0, 'value']);
  const body = item.getIn(['entity', 'field_body', 0, 'value']);
  const image_icon = item.getIn(['entity', 'field_image', 0, 'styles', 'original']);
  const image_modal = item.getIn(['entity', 'field_modal_image', 0, 'styles', 'original']);

  return (
    <div className="InfographicItem"
      onClick={() => {
        toggle(title, body, image_modal);
      }}
    >
      <div className="InfographicItem__image">
        <Image
          lazyload={false}
          src={image_icon}
        />
      </div>
      <div className="InfographicItem__content">
        <div className="InfographicItem__text">
          <h4 className="InfographicItem__text__title">{title}</h4>
          <WysiwygField
            property="schema:text"
            html={truncate(body, charLimit, openTag, closeTag, prettyEllipsis)}
            className="InfographicItem__text__body"
          />
        </div>
      </div>
    </div>
  );
};

export default InfographicItem;
